/* eslint-disable */
import {BaseInterfApi} from 'unityrpcjs/unityrpc.js'


export class FirmCompletion {
    constructor() {
        this.firmid = "";  // 0 require
        this.shortName = "";  // 1 require
        this.name = "";  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

FirmCompletion.__json_class__ = 'Firm.FirmCompletion'

export class FirmInterfApi extends BaseInterfApi {
    constructor(baseUrl, moduleName='Firm',
            interfName='FirmInterf', token='anonymous', ...args) {
        super(baseUrl, moduleName, interfName, token, ...args)
    }


    getFirmCompletions(key, context) {
        let params = {
            key: key,
            };
        let req = this.createRequest('getFirmCompletions', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getFirmCompletions'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

}


// WEBPACK FOOTER //
// ./src/apis/rpc/Firm/Firm.js